import styled from 'styled-components';

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 500px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 420px;
  }
`

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  height: 100%;
  width: 100%;

  h3 {
    font-size: 20px;
    font-weight: normal;
    text-align: center;
    color: ${props => props.theme.colors.greyDarker};

    strong {
      color: ${props => props.theme.colors.mainColor};
    }
  }

  > strong {
    font-size: 18px;
    font-weight: normal;
    text-align: center;
    color: ${props => props.theme.colors.mainColor};
  }

  small {
    width: 350px;
    margin-bottom: 20px;
    text-align: center;

    font-size: 14px;
    line-height: 16px;
    color: ${props => props.theme.colors.grey04};
  }

  > button#goBack {
    background-color: transparent;
    border: none;

    margin-top: 20px;

    color: ${props => props.theme.colors.mainColor};
    font-weight: 600;

    &:focus {
      text-decoration: underline;
    }
  }
`

export const Cards = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 0 20px;

  h3 {
    margin-bottom: 0;
  }

  span {
    font-size: 24px;
    margin: 4px;
    font-weight: 600;
    color: ${props => props.theme.colors.mainColor}
  }
`

export const GraphWrapper = styled.div`
  height: 200px;
  width:100%;
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 766px){
    height: 225px;
  }
`
